export const JIRA_TRIAL_LENGTH_14 = 14;
export const JIRA_TRIAL_LENGTH_30 = 30;
